import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import { Pill } from '@andes/badge';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { validateSnackbarColor } from '../../utils/validators';
import VehicleInspectionRow from '../vehicle-inspection-row';

const namespace = 'ui-pdp-vehicle-inspection-full-specs';

const lowercaseBadge = badge => (
  <Pill
    className={`${namespace}__pill`}
    color={validateSnackbarColor(badge.type.toLowerCase())}
    size={badge.font_size.toLowerCase()}
    hierarchy={badge.hierarchy.toLowerCase()}
    roundedCorners={['top-right', 'top-left', 'bottom-right', 'bottom-left']}
  >
    {badge.text}
  </Pill>
);

const VehicleInspectionFullSpecs = ({ header, badge, rows }) => (
  <div className={namespace}>
    <StyledLabel as="h2" className={`${namespace}__header`} {...header}>
      {badge && lowercaseBadge(badge)}
    </StyledLabel>
    {rows.map(row => (
      <VehicleInspectionRow key={row.title.text} {...row} />
    ))}
  </div>
);

VehicleInspectionFullSpecs.propTypes = {
  header: shape({
    text: string.isRequired,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  badge: shape({
    text: string,
    font_size: string,
    type: string,
    border: string,
    hierarchy: string,
  }),
  rows: arrayOf(
    shape({
      sections: arrayOf(
        shape({
          attributes: arrayOf(
            shape({
              icon: shape({
                id: string.isRequired,
                color: string,
                size: string,
              }),
              label: shape({
                text: string.isRequired,
                color: string,
                font_size: string,
                font_family: string,
                values: shape({
                  value_text: shape({
                    text: string,
                    color: string,
                    font_size: string,
                    font_family: string,
                  }),
                }),
              }),
            }),
          ),
        }),
      ).isRequired,
    }),
  ).isRequired,
};

VehicleInspectionFullSpecs.defaultProps = {
  header: {},
  description: {},
  badge: null,
  rows: [],
};

export default React.memo(VehicleInspectionFullSpecs);
